import { render } from "./UsersTransactions.vue?vue&type=template&id=1c33a8fd"
import script from "./UsersTransactions.vue?vue&type=script&lang=js"
export * from "./UsersTransactions.vue?vue&type=script&lang=js"

import "./UsersTransactions.vue?vue&type=style&index=0&id=1c33a8fd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UsersTransactions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c33a8fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c33a8fd', __exports__)) {
    api.reload('1c33a8fd', __exports__)
  }
  
  module.hot.accept("./UsersTransactions.vue?vue&type=template&id=1c33a8fd", () => {
    api.rerender('1c33a8fd', render)
  })

}


export default __exports__